import React from "react";

/**
 * Access surface — rendered as a code panel.
 * Monospace, hairline chrome, prompt characters. FIG.1 across the site.
 */
export function AccessGrid() {
  const rows = [
    { name: "deal_records",   tag: "finance",    state: "GRANTED", cls: "granted" },
    { name: "customer_pii",   tag: "restricted", state: "DENIED",  cls: "denied" },
    { name: "hr_records",     tag: "restricted", state: "DENIED",  cls: "denied" },
    { name: "source_systems", tag: "read_only",  state: "GRANTED", cls: "granted" },
  ];
  return (
    <div className="mkt-fig-code" data-testid="mkt-access-grid" role="region" aria-label="Access surface">
      <div className="mkt-fig-code-head">
        <span>access.surface&nbsp;·&nbsp;agent</span>
        <span>deny_by_default = true</span>
      </div>
      <div className="mkt-fig-code-body">
        <div className="mkt-fig-code-comment">access_request { }</div>
        <div className="mkt-fig-code-comment">policy = deny_by_default</div>
        <hr className="mkt-fig-code-sep" />
        {rows.map((r) => (
          <div key={r.name} className="mkt-fig-code-row">
            <span className="prompt">▸</span>
            <span className="k">
              {r.name}
              <span className="tag">{r.tag}</span>
            </span>
            <span className={`status ${r.cls}`}>{r.state}</span>
          </div>
        ))}
      </div>
      <div className="mkt-fig-code-foot">
        <span>2 / 4 granted &nbsp;·&nbsp; revocable</span>
        <span>your keys, your data</span>
      </div>
    </div>
  );
}
